// import { API_BASE_URL } from "../api/config";

const API_BASE_URL = process.env.REACT_APP_DEFAULT_API_BASE_URL;

// best bet

export const fetchTournamentsDataApi = async (channelId, langid , sportId) => {
    try {
        const response = await fetch(`${API_BASE_URL}BestBetBuilder/get_tournaments_new?channelid=${channelId}&langid=${langid}&sportid=${sportId}`)
        const data = await response.json();
        if (data && Object.keys(data).length > 0 && data.statuscode === 200) {
            return data
        } else {
            return {};
        }
    } catch (error) {
        console.log(error);
        return {};
    }
}

export const fetchMatchDataApi = async (channelId, langid, sportId, leagueId) => {
    try {
        const response = await fetch(`${API_BASE_URL}BestBetBuilder/get_events?channelid=${channelId}&langid=${langid}&sportid=${sportId}&tournamnetid=${leagueId}`)
        const data = await response.json();
        if (data && Object.keys(data).length > 0 && data.statuscode === 200) {
            return data
        } else {
            return {};
        }
    } catch (error) {
        console.error(error);
        return {};
    }
}

export const fetchEventTopBestBetDataApi = async (channelId,langId,sportId,matchId,count,flag) => {
    try {
        const response = await fetch(`${API_BASE_URL}BestBetBuilder/get_event_top_bestbets?channelid=${channelId}&isInstantBet=${flag}&langid=${langId}&sportid=${sportId}&matchid=${matchId}&${count ? `count=${count}` : count=3}`)
        const data = await response.json();
        if (data && Object.keys(data).length > 0 && data.statuscode === 200) {
            return data
        } else {
            return {};
        }
    } catch (error) {
        console.error(error);
        return {};
    }
}

export const fetchMarketBetBuilderDataDataApi = async (channelId, langId , sportId, matchId, marketId, noofsetlection) => {
    try {
        const response = await fetch(`${API_BASE_URL}BestBetBuilder/get_event_market_betbuilder?channelid=${channelId}&langid=${langId}&sportid=${sportId}&matchid=${matchId}&marketid=${marketId}&legs=${noofsetlection}`)
        const data = await response.json();
        if (data && Object.keys(data).length > 0 && data.statuscode === 200) {
            return data
        } else {
            return {};
        }
    } catch (error) {
        console.error(error);
        return {};
    }
}

export const fetchReplacedMarketBetBuilder = async (channelId, matchid , marketId ,noofsetlection , excludemarketid, indcludemarketid, langId) => {
    // console.log(indcludemarketid);
    try {
        const response = await fetch(`${API_BASE_URL}BestBetBuilder/get_event_market_betbuilder_replacement?channelid=${channelId}&langid=${langId}&sportid=5&matchid=${matchid}&marketid=${marketId}&legs=${noofsetlection}&excludemarketid=${excludemarketid}&includemarketids=${indcludemarketid}`)
        const data = await response.json();
        if (data && Object.keys(data).length > 0 && data.statuscode === 200) {
            return data
        } else {
            return {};
        }
    } catch (error) {
        console.error(error);
        return {};
    }
}

// fetch All Market Categories
export const fetchAllMarketCategories = async (channelId, langId , sportId,) => {
    try {
        const response = await fetch(`${API_BASE_URL}BestBetBuilder/get_bestbet_marketcategories?channelid=${channelId}&langid=${langId}&sportid=${sportId}`);
        const data = await response.json();
        if (data && Object.keys(data).length > 0 && data.statuscode === 200) {
            return data
        } else {
            return {};
        }
    } catch (error) {
        console.log('fetchAllMarketCategories', error)
        return {};
    }
}
// fetch All Market SubCategory Data
export const fetchAllMarketSubCategoryDataData = async (channelId, langId , sportId, matchid, marketcategoryid) => {
    try {
        const response = await fetch(`${API_BASE_URL}BestBetBuilder/get_event_marketcategory_bestbets?channelid=${channelId}&langid=${langId}&sportid=${sportId}&matchid=${matchid}&marketcategoryid=${marketcategoryid}`)
        const data = await response.json();
        if (data && Object.keys(data).length > 0 && data.statuscode === 200) {
            return data
        } else {
            return data.statuscode;
        }
    } catch (error) {
        console.error(error);
        return {};
    }
}

// multibet

export const fetchMultibetDataApi = async (count, win , stake, mastermarketid, leagueId, langid) => {
    try {
        const response = await fetch(`${API_BASE_URL}Multibet/get_multibets?channelid=1&sportid=5&leg=${count}&stake=${stake}&win=${win}&langid=${langid}${leagueId?`&leagues=${leagueId}`: ''}${mastermarketid ? `&markets=${mastermarketid}`: ''}`)
        const data = await response.json();
        if (data && Object.keys(data).length > 0 ) {
            return data
        } else {
            return {};
        }
    } catch (error) {
        console.error(error);
        return {};
    }
}

export const fetchMultibetleaguesDataApi = async (langid) => {
    try {
        const response = await fetch(`${API_BASE_URL}Multibet/get_multibets_leagues?channelid=1&sportid=5&langid=${langid}`)
        const data = await response.json();
        if (data && Object.keys(data).length > 0 ) {
            return data
        } else {
            return {};
        }
    } catch (error) {
        console.error(error);
        return {};
    }
}

export const fetchMultibetmarketsDataApi = async (langid) => {
    try {
        const response = await fetch(`${API_BASE_URL}Multibet/get_multibets_markets?channelid=1&sportid=5&langid=${langid}`)
        const data = await response.json();
        if (data && Object.keys(data).length > 0 ) {
            return data
        } else {
            return {};
        }
    } catch (error) {
        console.error(error);
        return {};
    }
}

export const fetchMultibetReplaceDataApi = async (excludematches , minodds , maxodds, leagueId, mastermarketid, langid ) => {
    try {
        const response = await fetch(`${API_BASE_URL}Multibet/get_multibet_replacement?channelid=1&sportid=5&langid=${langid}&excludematches=${excludematches}&minodds=${minodds}&maxodds=${maxodds}${leagueId?`&leagues=${leagueId}`:''}${mastermarketid?`&markets=${mastermarketid}`:''}`)
        const data = await response.json();
        if (data && Object.keys(data).length > 0 ) {
            return data
        } else {
            return {};
        }
    } catch (error) {
        console.error(error);
        return {};
    }
}

// TREBLE

export const fetchTriplemarketsDataApi = async (langid) => {
    try {
        const response = await fetch(`${API_BASE_URL}Multibet/get_multibets_markets_trebles?channelid=1&sportid=5&langid=${langid}`)
        const data = await response.json();
        if (data && Object.keys(data).length > 0 ) {
            return data
        } else {
            return {};
        }
    } catch (error) {
        console.error(error);
        return {};
    }
}

export const fetchTripleDataApi = async (langid, leagues, mastermarketid) => {
    try {
        const response = await fetch(`${API_BASE_URL}Multibet/get_multibets_trebles?langid=${langid}&channelid=1&sportid=5${leagues?`&leagues=${leagues}`: ''}${mastermarketid ? `&markets=${mastermarketid}`: ''}`)
        const data = await response.json();
        if (data && Object.keys(data).length > 0 ) {
            return data
        } else {
            return {};
        }
    } catch (error) {
        console.error(error);
        return {};
    }
}

export const fetchTripleReplaceDataApi = async (excludematches ,leagueId, mastermarketid, langid ) => {
    try {
        const response = await fetch(`${API_BASE_URL}Multibet/get_multibet_replacement_trebles?channelid=1&sportid=5&langid=${langid}&excludematches=${excludematches}${leagueId?`&leagues=${leagueId}`:''}${mastermarketid?`&markets=${mastermarketid}`:''}`)
        const data = await response.json();
        if (data && Object.keys(data).length > 0 ) {
            return data
        } else {
            return {};
        }
    } catch (error) {
        console.error(error);
        return {};
    }
}


export const fetchJoinUserApi = async (formData) => {
    try {
        const response = await fetch(`${API_BASE_URL}Subscription/join_user`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        });

        const data = await response.json();

        if (data && Object.keys(data).length > 0) {
            return data;
        } else {
            return {};
        }
    } catch (error) {
        console.error(error);
        return {};
    }
};


export const fetchAllMarketCategoriesBestbetsAll = async (channelId, langId , sportId, matchid) => {
    try {
        const response = await fetch(`${API_BASE_URL}BestBetBuilder/get_event_marketcategory_bestbets_all?channelid=${channelId}&langid=${langId}&sportid=${sportId}&matchid=${matchid}`);
        const data = await response.json();
        if (data && Object.keys(data).length > 0 && data.statuscode === 200) {
            return data
        } else {
            return {};
        }
    } catch (error) {
        console.log('fetchAllMarketCategories', error)
        return {};
    }
}

export const fetchDisableEnablebetbuilder = async (channelId, langId , sportId, matchid, marketkey) => {
    try {
        const response = await fetch(`${API_BASE_URL}BestBetBuilder/get_custom_event_market_betbuilder?channelid=${channelId}&langid=${langId}&sportid=${sportId}&matchid=${matchid}&marketkey=${marketkey}`);
        const data = await response.json();
        if (data && Object.keys(data).length > 0 && data.statuscode === 200) {
            return data
        } else {
            return {};
        }
    } catch (error) {
        console.log('fetchAllMarketCategories', error)
        return {};
    }
}


export const fetchSubscriptionRegisterUserApi = async (formData) => {
    try {
        const response = await fetch(`${API_BASE_URL}Subscription/register_user`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        });

        const data = await response.json();

        if (data && Object.keys(data).length > 0) {
            return data;
        } else {
            return data;
        }
    } catch (error) {
        console.error(error);
        return {};
    }
};

export const fetchSubscriptionLoginUserApi = async (email, password) => {
    try {
        const response = await fetch(`${API_BASE_URL}Subscription/login?email=${email}&password=${password}`);
        const data = await response.json();
        if (data && Object.keys(data).length > 0 && data.statuscode === 200) {
            return data
        } else {
            return data;
        }
    } catch (error) {
        console.log('fetchSubscriptionLoginUserApi', error)
        return {};
    }
}

export const fetchSubscriptionForgotPasswordUserApi = async (email) => {
    try {
        const response = await fetch(`${API_BASE_URL}Subscription/forgot_password?email=${email}`);
        const data = await response.json();
        if (data && Object.keys(data).length > 0 && data.statuscode === 200) {
            return data
        } else {
            return data;
        }
    } catch (error) {
        console.log('fetchSubscriptionLoginUserApi', error)
        return {};
    }
}

export const fetchSubscriptionChangePasswordUserApi = async (email, useruniqueid, newPassword, token) => {
    try {
        const url = `${API_BASE_URL}Subscription/change_password?email=${encodeURIComponent(email)}&useruniqueid=${encodeURIComponent(useruniqueid)}&password=${encodeURIComponent(newPassword)}&token=${encodeURIComponent(token)}`;

        const response = await fetch(url, {
            method: 'POST', // or 'GET' if your backend expects GET
            headers: {
                'Content-Type': 'application/json',
            },
        });

        const data = await response.json();

        return data && Object.keys(data).length > 0 ? data : data;
    } catch (error) {
        console.error(error);
        return {};
    }
};


export const fetchSubscriptionActivateUserApi = async (email, useruniqueid, token) => {
    try {
        const url = `${API_BASE_URL}Subscription/activate_user?email=${encodeURIComponent(email)}&useruniqueid=${encodeURIComponent(useruniqueid)}&token=${encodeURIComponent(token)}`;

        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        const data = await response.json();

        return data && Object.keys(data).length > 0 ? data : data;
    } catch (error) {
        console.error(error);
        return {};
    }
};



export const fetchSubscriptionRequestActivation = async (email) => {
    try {
        const response = await fetch(`${API_BASE_URL}Subscription/request_activation?email=${email}`);
        const data = await response.json();
        if (data && Object.keys(data).length > 0 && data.statuscode === 200) {
            return data
        } else {
            return data;
        }
    } catch (error) {
        console.log('fetchSubscriptionLoginUserApi', error)
        return {};
    }
}

export const fetchSubscriptionCheckIpApi = async (ip) => {
    try {
        const url = `${API_BASE_URL}Subscription/check_ip?ip=${ip}`;

        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        const data = await response.json();

        return data && Object.keys(data).length > 0 ? data : data;
    } catch (error) {
        console.error(error);
        return {};
    }
};

export const fetchlanguages = async (channelId,sportId) => {
    try {
        const response = await fetch(`${API_BASE_URL}BestBetBuilder/get_languages?channelid=${channelId}&sportid=${sportId}`)
        const data = await response.json();
        if (data && Object.keys(data).length > 0 && data.statuscode === 200) {
            return data
        } else {
            return {};
        }
    } catch (error) {
        console.error(error);
        return {};
    }
}